
import axios from 'axios'
import Qs from 'qs'
import store from '../store/index'
import router from '../router/index'
import dsBridge from "../utils/dsbridge"
import { getWXCode,getApolloToken } from "../utils/getWXCode"
import { appAuth } from "../utils/userAuth"

let Ax = axios.create({
    baseURL: process.env.apiHost,
    headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'language': localStorage.lang ? localStorage.lang : 'CHS',
        'token': ''
    },
    paramsSerializer: function (params) {
        return Qs.stringify(params, {arrayFormat: 'repeat'})
    }
})

const excludeList = ['Statistics', 'File/SendMai', 'api-do-portal-log', 'debug/url', 'Comment/Total']

Ax.interceptors.request.use(function (config) {

    if(process.env.NODE_ENV === "development") {
        localStorage.ADAccount = 'jian.xin.o'
        localStorage.Email = null
        localStorage.EnName = 'JIAN XIN'
        localStorage.CnName = '辛坚'
        localStorage.token = 'cb808a734fd9676dcd9badc0e0c27754'
    }
    
    config.headers.token = localStorage.getItem('token')

    let matchingArr = excludeList.filter((item) => {
        return config.url.indexOf(item) > -1
    })
    if (matchingArr.length === 0) {  // 不在白名单中
        store.commit('AJAX_REQUEST')
    }

    return config

}, function (error) {
    return Promise.reject(error)
})


Ax.interceptors.response.use(function (response) {

    let matchingArr = excludeList.filter((item) => {
        return response.config.url.indexOf(item) > -1
    })
    if (matchingArr.length === 0) {  // 不在白名单中
        store.commit('AJAX_REPONSE')
    }
    
    if (response.data.Code === 403 || response.data.Code === 410) {
        localStorage.removeItem('token')
        if(process.env.NODE_ENV !== "development") {
            if(localStorage.AUTH_TYPE === 'WECHAT'){
                getWXCode()
                return
            }

            if(localStorage.AUTH_TYPE === 'APOLLO'){
                // 更新apollo token
                dsBridge.call('ApolloApp.invokeAsyn', {
                    methodName: "refreshToken"
                }, function(res) {
                    let _res = JSON.parse(res);
                    appAuth(_res.data.token, 3).then(()=>{
                        window.location.reload()
                    });
                });
                return
            }
            if(localStorage.AUTH_TYPE === 'TOOLKIT'){
                // 更新mate token
                const mateToken = jsBridge.call("toolkit.getTokenSyn").data.token
                //这里肯定没有token了，可以直接调用appAuth 获取ssotoken
                appAuth(mateToken,1); 
            }
        }
    }

    return response

}, function (error) {
    return Promise.reject(error)
})

export default Ax



// WEBPACK FOOTER //
// ./src/api/axios.js